/**
 * Marble Fangs Size Advisor — frozen engine port (v1-2026-09-26)
 * Faithful JS port of size_advisor_sim.py + p1_overlay.py + frozen_recommend.py
 * Pure: no DOM, no analytics, no Shopify IDs.
 * P1a ALWAYS on. DELTA_P1 = 0.55
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.MfSizeAdvisorEngine = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var FROZEN_VERSION = 'v1-2026-09-26';
  var SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
  var SIZE_INDEX = { S: 0, M: 1, L: 2, XL: 3, XXL: 4 };

  var TEE = {
    S: { length: 27.5, chestFlat: 21.5, sleeve: 17.5 },
    M: { length: 28.5, chestFlat: 22.5, sleeve: 18.0 },
    L: { length: 29.5, chestFlat: 23.5, sleeve: 18.5 },
    XL: { length: 30.5, chestFlat: 24.5, sleeve: 19.0 },
    XXL: { length: 31.5, chestFlat: 25.5, sleeve: 19.5 }
  };
  var HOODIE = {
    S: { length: 27.0, chestFlat: 23.5, shoulder: 21.0 },
    M: { length: 28.0, chestFlat: 24.5, shoulder: 22.0 },
    L: { length: 29.0, chestFlat: 25.5, shoulder: 23.0 },
    XL: { length: 30.0, chestFlat: 26.5, shoulder: 24.0 },
    XXL: { length: 31.0, chestFlat: 27.5, shoulder: 25.0 }
  };

  var ANSUR_BMI = 27.7;
  var ANSUR_CHEST_STATURE_RATIO = 105.8 / 175.6;
  var BMI_EXPONENT = 0.5;
  var BMI_FLOOR = 16.0;

  var BUILDS = ['slim', 'average', 'muscular', 'broad'];
  var BUILD_SIZE_NUDGE = { slim: 0.2, average: 0.0, muscular: -0.08, broad: -0.2 };
  var BUILD_NUDGE_MAX = 0.2;
  var BUILD_UNC_EXTRA = { slim: 0.5, average: 0.0, muscular: 0.25, broad: 0.5 };

  var TEE_EASE = {
    fitted: { target: 2.5, min: 0.5, max: 4.5 },
    regular: { target: 5.0, min: 2.5, max: 7.5 },
    relaxed: { target: 8.5, min: 5.5, max: 12.0 }
  };
  var HOODIE_EASE = {
    fitted: { target: 5.0, min: 2.5, max: 7.5 },
    regular: { target: 8.0, min: 5.0, max: 11.0 },
    relaxed: { target: 11.0, min: 8.0, max: 15.0 }
  };
  var EASE_TARGETS_PROVISIONAL = true;

  var LENGTH_K_TEE = 0.405;
  var LENGTH_K_HOODIE = 0.4;
  var LENGTH_BAND_LO = 2.0;
  var LENGTH_BAND_HI = 2.5;
  var LENGTH_BAND_LO_EXP = 3.0;
  var LENGTH_BAND_HI_EXP = 3.5;

  var CHEST_UNCERTAINTY_IN = 1.5;
  var LENGTH_UNCERTAINTY_IN = 1.0;

  var EASE_SCORE_SCALE = 2.0;
  var LEN_SCORE_SCALE = 1.5;
  var PTP_SCORE_SCALE = 0.75;
  var CLOSE_DIST_DELTA = 0.35;

  var PTP_MATCH_PRIMARY = 1.0;
  var PTP_MATCH_EXPANDED = 2.0;
  var PTP_FIT_NUDGE = { fitted: -0.25, regular: 0.0, relaxed: 0.25 };

  var OUTCOME_A = 'A_confident';
  var OUTCOME_B = 'B_qualified';
  var OUTCOME_C = 'C_no_confident';
  var OUTCOME_LABELS = {};
  OUTCOME_LABELS[OUTCOME_A] = 'Confident recommendation';
  OUTCOME_LABELS[OUTCOME_B] = 'Qualified recommendation';
  OUTCOME_LABELS[OUTCOME_C] = 'No confident recommendation';

  var CIRC_STEP = 2.0;
  var CIRC_HALF = 1.0;
  var DELTA_P1 = CLOSE_DIST_DELTA + BUILD_NUDGE_MAX; // 0.55
  var USE_P1A_MARGIN_GATE = true;

  function clamp(x, lo, hi) {
    return Math.max(lo, Math.min(hi, x));
  }

  function bmi(heightIn, weightLb) {
    return (703.0 * weightLb) / (heightIn * heightIn);
  }

  function estimateChestCirc(heightIn, weightLb, build) {
    var b = bmi(heightIn, weightLb);
    var ratio =
      ANSUR_CHEST_STATURE_RATIO * Math.pow(Math.max(b, BMI_FLOOR) / ANSUR_BMI, BMI_EXPONENT);
    var chestBase = ratio * heightIn;
    return {
      bmi: Math.round(b * 1000) / 1000,
      chestStatureRatio: Math.round(ratio * 10000) / 10000,
      chestBaseIn: Math.round(chestBase * 1000) / 1000,
      buildMult: 1.0,
      chestCircIn: Math.round(chestBase * 1000) / 1000,
      buildUncExtraIn: BUILD_UNC_EXTRA[build] != null ? BUILD_UNC_EXTRA[build] : 0.0
    };
  }

  function preferredLength(heightIn, garment) {
    var k = garment === 'tee' ? LENGTH_K_TEE : LENGTH_K_HOODIE;
    return k * heightIn;
  }

  function easeSpec(garment, preferredFit) {
    return garment === 'tee' ? TEE_EASE[preferredFit] : HOODIE_EASE[preferredFit];
  }

  function garmentCirc(chestFlat) {
    return chestFlat * 2.0;
  }

  function chartFor(garment) {
    return garment === 'tee' ? TEE : HOODIE;
  }

  function round3(x) {
    return Math.round(x * 1000) / 1000;
  }
  function round4(x) {
    return Math.round(x * 10000) / 10000;
  }
  function round2(x) {
    return Math.round(x * 100) / 100;
  }

  function customerCopy(outcome, primary, alternate, garment, preferredFit, hasPtp, conflict) {
    var gword = garment === 'tee' ? 'tee' : 'hoodie';
    var fitword = preferredFit;
    var ptpInvite =
      ' Want a sharper answer? Lay a ' +
      gword +
      ' that already fits the way you like flat on a table and measure pit-to-pit (armpit to armpit across the chest). Enter that number and we’ll compare it directly to our ' +
      gword +
      ' sizes.';

    if (outcome === OUTCOME_C) {
      var base =
        "We can’t recommend a size with confidence for this height and weight on this " +
        gword +
        ' — the chest room and length you need don’t land cleanly on one chart size.';
      if (conflict) {
        base +=
          ' Your proportions pull in two directions (chest vs length), so a single size won’t fit ideally in every dimension.';
      }
      if (hasPtp) {
        base +=
          ' Even with your favorite garment measurement, the proportions may not ideal-fit this cut — chest preference and length still disagree.';
        return base + ' Reach out if you’d like help picking a compromise.';
      }
      return base + ptpInvite;
    }

    if (outcome === OUTCOME_A) {
      var msg =
        'Based on what you entered, **' +
        primary +
        '** should fit the way you like for a ' +
        fitword +
        ' ' +
        gword +
        '.';
      if (hasPtp) {
        msg =
          'Based on your height and the ' +
          gword +
          ' measurement you entered, **' +
          primary +
          '** should feel close to a favorite that already fits.';
      }
      if (alternate) {
        msg += ' **' + alternate + '** is also close if you want a slightly different feel.';
      }
      return msg;
    }

    // B
    if (primary && alternate) {
      var larger = SIZE_INDEX[primary] >= SIZE_INDEX[alternate] ? primary : alternate;
      var smaller = SIZE_INDEX[primary] <= SIZE_INDEX[alternate] ? primary : alternate;
      msg =
        'You’re likely between **' +
        primary +
        '** and **' +
        alternate +
        '** for a ' +
        fitword +
        ' ' +
        gword +
        '. If you prefer a bit more room, lean ' +
        larger +
        '; for a cleaner line, lean ' +
        smaller +
        '.';
    } else if (primary) {
      msg =
        'We suggest **' +
        primary +
        '** for a ' +
        fitword +
        ' ' +
        gword +
        ', with some uncertainty — fit may not be perfect in every dimension.';
    } else {
      msg = "We don’t have a single clear size for this " + gword + ' yet.';
    }
    if (conflict) {
      msg +=
        ' Your chest room and length preferences pull toward different sizes, so this is a compromise.';
    }
    if (hasPtp && conflict) {
      msg +=
        ' Your favorite measurement helps on width, but length still disagrees — proportions may not ideal-fit this cut.';
    } else if (!hasPtp) {
      msg += ptpInvite;
    }
    return msg;
  }

  function classifyOutcome(opts) {
    var reasons = [];
    if (opts.allEmpty || opts.lengthBlocksPtp) {
      reasons.push('empty_intersection_or_length_blocks');
      if (opts.strongConflict) reasons.push('strong_dimension_conflict');
      return { outcome: OUTCOME_C, reasons: reasons };
    }
    if (opts.expandedOnly && opts.strongConflict) {
      reasons.push('expanded_bands_and_strong_conflict');
      return { outcome: OUTCOME_C, reasons: reasons };
    }
    if (
      opts.primarySetN > 0 &&
      !opts.expandedOnly &&
      !opts.strongConflict &&
      opts.plausibleN <= 2 &&
      (!opts.hasCloseAlt || opts.ptpConfirmsPrimary)
    ) {
      reasons.push('narrow_primary_set_clear_winner');
      if (opts.hasPtp && opts.ptpConfirmsPrimary) reasons.push('ptp_confirms');
      return { outcome: OUTCOME_A, reasons: reasons };
    }
    if (
      opts.hasPtp &&
      opts.ptpConfirmsPrimary &&
      !opts.expandedOnly &&
      !opts.strongConflict &&
      opts.primarySetN > 0
    ) {
      reasons.push('ptp_direct_preference_clear');
      return { outcome: OUTCOME_A, reasons: reasons };
    }
    if (opts.expandedOnly) reasons.push('expanded_bands_used');
    if (opts.hasCloseAlt) reasons.push('close_call_between_sizes');
    if (opts.plausibleN >= 3) reasons.push('wide_plausible_set');
    if (opts.conflict) reasons.push('dimension_conflict');
    if (!opts.hasPtp) reasons.push('invite_same_category_ptp');
    if (!reasons.length) reasons.push('boundary_or_provisional_ease');
    return { outcome: OUTCOME_B, reasons: reasons };
  }

  function recommend(garment, heightIn, weightLb, build, preferredFit, favoritePtp, ptpGarmentType) {
    if (garment !== 'tee' && garment !== 'hoodie') throw new Error('bad garment');
    if (['fitted', 'regular', 'relaxed'].indexOf(preferredFit) < 0) throw new Error('bad fit');
    if (BUILDS.indexOf(build) < 0) throw new Error('bad build');

    var chart = chartFor(garment);
    var chestInfo = estimateChestCirc(heightIn, weightLb, build);
    var bodyChest = chestInfo.chestCircIn;
    var prefLen = preferredLength(heightIn, garment);
    var easeT = easeSpec(garment, preferredFit);

    var ptpSame =
      favoritePtp != null && ptpGarmentType === garment && favoritePtp > 0;
    var ptpCross =
      favoritePtp != null &&
      ptpGarmentType != null &&
      ptpGarmentType !== garment &&
      favoritePtp > 0;
    var ptpTarget = null;
    if (ptpSame) {
      ptpTarget = favoritePtp + (PTP_FIT_NUDGE[preferredFit] != null ? PTP_FIT_NUDGE[preferredFit] : 0);
    }

    var chestUnc = CHEST_UNCERTAINTY_IN + Number(chestInfo.buildUncExtraIn);
    var buildNudgeScale;
    if (ptpSame) {
      chestUnc = 0.5;
      buildNudgeScale = 0.0;
    } else {
      buildNudgeScale = 1.0;
    }

    var easeMinP = easeT.min - chestUnc;
    var easeMaxP = easeT.max + chestUnc;
    var easeMinX = easeT.min - 2 * chestUnc;
    var easeMaxX = easeT.max + 2 * chestUnc;

    var lenLoP = prefLen - LENGTH_BAND_LO - LENGTH_UNCERTAINTY_IN;
    var lenHiP = prefLen + LENGTH_BAND_HI + LENGTH_UNCERTAINTY_IN;
    var lenLoX = prefLen - LENGTH_BAND_LO_EXP - LENGTH_UNCERTAINTY_IN;
    var lenHiX = prefLen + LENGTH_BAND_HI_EXP + LENGTH_UNCERTAINTY_IN;

    var evals = [];
    for (var si = 0; si < SIZES.length; si++) {
      var s = SIZES[si];
      var length = chart[s].length;
      var flat = chart[s].chestFlat;
      var gcirc = garmentCirc(flat);
      var ease = gcirc - bodyChest;
      var ld = length - prefLen;
      var ptpD = ptpSame && favoritePtp != null ? flat - favoritePtp : null;

      var chestOkP = ease >= easeMinP && ease <= easeMaxP;
      var lengthOkP = length >= lenLoP && length <= lenHiP;
      var chestOkX = ease >= easeMinX && ease <= easeMaxX;
      var lengthOkX = length >= lenLoX && length <= lenHiX;

      var ptpOkP = false;
      var ptpOkX = false;
      var inPrim, inExp;
      if (ptpSame && ptpTarget != null) {
        ptpOkP = Math.abs(flat - ptpTarget) <= PTP_MATCH_PRIMARY;
        ptpOkX = Math.abs(flat - ptpTarget) <= PTP_MATCH_EXPANDED;
        inPrim = ptpOkP && lengthOkP;
        inExp = ptpOkX && lengthOkX;
      } else {
        inPrim = chestOkP && lengthOkP;
        inExp = chestOkX && lengthOkX;
      }

      evals.push({
        size: s,
        length: length,
        chestFlat: flat,
        garmentCirc: gcirc,
        ease: round3(ease),
        lengthDelta: round3(ld),
        ptpDelta: ptpD == null ? null : round3(ptpD),
        chestOkPrimary: chestOkP,
        lengthOkPrimary: lengthOkP,
        chestOkExpanded: chestOkX,
        lengthOkExpanded: lengthOkX,
        ptpOkPrimary: ptpOkP,
        ptpOkExpanded: ptpOkX,
        inPlausiblePrimary: inPrim,
        inPlausibleExpanded: inExp,
        dist: null,
        distComponents: null
      });
    }

    var primarySet = evals.filter(function (e) {
      return e.inPlausiblePrimary;
    });
    var expandedSet = evals.filter(function (e) {
      return e.inPlausibleExpanded;
    });
    var usedExpanded = false;
    var allEmpty = false;
    var warnings = [];
    var lengthBlocksPtp = false;
    var candidateSet;

    if (primarySet.length) {
      candidateSet = primarySet;
    } else if (expandedSet.length) {
      candidateSet = expandedSet;
      usedExpanded = true;
      warnings.push(
        'PRIMARY_BANDS_EMPTY: no size satisfied both width and length primary bands; expanded bands used. Fit confidence is lower.'
      );
    } else {
      candidateSet = evals;
      usedExpanded = true;
      allEmpty = true;
      warnings.push(
        'ALL_BANDS_EMPTY: length and width disagree beyond expanded tolerance. No confident recommendation.'
      );
    }

    if (ptpSame && favoritePtp != null) {
      var tight = evals.filter(function (e) {
        return Math.abs(e.chestFlat - favoritePtp) <= PTP_MATCH_PRIMARY;
      });
      if (tight.length && !tight.some(function (e) {
        return e.lengthOkPrimary;
      })) {
        lengthBlocksPtp = true;
        warnings.push(
          'LENGTH_BLOCKS_PTP: favorite pit-to-pit matches a chart width, but those size(s) fail length compatibility for this height. PTP does not override length.'
        );
      }
    }

    var byChest = evals.reduce(function (best, e) {
      return Math.abs(e.ease - easeT.target) < Math.abs(best.ease - easeT.target) ? e : best;
    });
    var byLength = evals.reduce(function (best, e) {
      return Math.abs(e.length - prefLen) < Math.abs(best.length - prefLen) ? e : best;
    });
    var idxDelta = Math.abs(SIZE_INDEX[byChest.size] - SIZE_INDEX[byLength.size]);
    var conflict = idxDelta > 1;
    var strongConflict = idxDelta >= 2;
    if (conflict) {
      warnings.push(
        'DIMENSION_CONFLICT: chest-preferred size ' +
          byChest.size +
          ' and length-preferred size ' +
          byLength.size +
          ' differ by >1 size.'
      );
    }

    if (ptpSame) {
      warnings.push(
        'PTP_DIRECT_PREFERENCE: same-category favorite pit-to-pit compared directly to garment chestFlat (not converted via assumed ease).'
      );
    } else if (ptpCross) {
      warnings.push(
        'PTP_CROSS_CATEGORY_IGNORED: favorite measurement is a different garment type than the item being shopped; v1 does not convert cross-category PTP. Enter a same-category measurement for a stronger answer.'
      );
    } else {
      warnings.push(
        'NO_TRUE_CHEST: body chest is estimated from height/weight; ease bands include uncertainty. Optional same-category pit-to-pit tightens this. Ease targets are PROVISIONAL.'
      );
    }
    if (EASE_TARGETS_PROVISIONAL && !ptpSame) {
      warnings.push(
        'PROVISIONAL_EASE_TARGETS: fitted/regular/relaxed ease numbers are industry-heuristic and not MF try-on calibrated; confidence policy absorbs that uncertainty.'
      );
    }

    var nudgeBase =
      (BUILD_SIZE_NUDGE[build] != null ? BUILD_SIZE_NUDGE[build] : 0) * buildNudgeScale;

    for (var ci = 0; ci < candidateSet.length; ci++) {
      var e = candidateSet[ci];
      var lenTerm = Math.abs(e.length - prefLen) / LEN_SCORE_SCALE;
      var comps = { length: round4(lenTerm) };
      var dist, easeTerm, buildTerm, ptpTerm;
      if (ptpSame && ptpTarget != null) {
        ptpTerm = Math.abs(e.chestFlat - ptpTarget) / PTP_SCORE_SCALE;
        easeTerm = 0.25 * (Math.abs(e.ease - easeT.target) / EASE_SCORE_SCALE);
        buildTerm = 0.0;
        dist = ptpTerm + lenTerm + easeTerm;
        comps.ptp = round4(ptpTerm);
        comps.ease_secondary = round4(easeTerm);
        comps.build = 0.0;
      } else {
        easeTerm = Math.abs(e.ease - easeT.target) / EASE_SCORE_SCALE;
        var rawBias = nudgeBase * (SIZE_INDEX[e.size] / 4.0);
        buildTerm = clamp(rawBias, -BUILD_NUDGE_MAX, BUILD_NUDGE_MAX);
        dist = easeTerm + lenTerm + buildTerm;
        comps.ease = round4(easeTerm);
        comps.build = round4(buildTerm);
      }
      e.dist = dist;
      e.distComponents = comps;
    }

    var ranked = candidateSet.slice().sort(function (a, b) {
      var da = a.dist != null ? a.dist : 99.0;
      var db = b.dist != null ? b.dist : 99.0;
      if (da !== db) return da - db;
      return Math.abs(a.ease - easeT.target) - Math.abs(b.ease - easeT.target);
    });
    var primary = ranked[0];
    var alternate = null;
    var hasCloseAlt = false;
    if (
      ranked.length > 1 &&
      ranked[1].dist != null &&
      primary.dist != null &&
      ranked[1].dist <= primary.dist + CLOSE_DIST_DELTA
    ) {
      alternate = ranked[1];
      hasCloseAlt = true;
    }

    var geoEaseLo, geoEaseHi;
    if (garment === 'tee') {
      geoEaseLo = TEE_EASE.fitted.min - chestUnc;
      geoEaseHi = TEE_EASE.relaxed.max + chestUnc;
    } else {
      geoEaseLo = HOODIE_EASE.fitted.min - chestUnc;
      geoEaseHi = HOODIE_EASE.relaxed.max + chestUnc;
    }

    var plausibleBeforeFit;
    if (ptpSame && ptpTarget != null) {
      plausibleBeforeFit = evals
        .filter(function (ev) {
          return Math.abs(ev.chestFlat - ptpTarget) <= PTP_MATCH_EXPANDED && ev.lengthOkPrimary;
        })
        .map(function (ev) {
          return ev.size;
        });
      if (!plausibleBeforeFit.length) {
        plausibleBeforeFit = evals
          .filter(function (ev) {
            return Math.abs(ev.chestFlat - ptpTarget) <= PTP_MATCH_EXPANDED && ev.lengthOkExpanded;
          })
          .map(function (ev) {
            return ev.size;
          });
      }
    } else {
      plausibleBeforeFit = evals
        .filter(function (ev) {
          return ev.ease >= geoEaseLo && ev.ease <= geoEaseHi && ev.lengthOkPrimary;
        })
        .map(function (ev) {
          return ev.size;
        });
      if (!plausibleBeforeFit.length) {
        plausibleBeforeFit = evals
          .filter(function (ev) {
            return ev.ease >= geoEaseLo && ev.ease <= geoEaseHi && ev.lengthOkExpanded;
          })
          .map(function (ev) {
            return ev.size;
          });
      }
    }

    var ptpConfirmsPrimary = false;
    if (ptpSame && favoritePtp != null) {
      ptpConfirmsPrimary = Math.abs(primary.chestFlat - favoritePtp) <= 0.5;
    }

    var classified = classifyOutcome({
      primarySetN: primarySet.length,
      expandedOnly: usedExpanded && !allEmpty,
      allEmpty: allEmpty,
      conflict: conflict,
      strongConflict: strongConflict,
      plausibleN: allEmpty ? 0 : candidateSet.length,
      hasCloseAlt: hasCloseAlt,
      hasPtp: ptpSame,
      ptpConfirmsPrimary: ptpConfirmsPrimary,
      lengthBlocksPtp: lengthBlocksPtp
    });

    var showSize = primary.size;
    var showAlt = alternate == null ? null : alternate.size;
    var customerMessage = customerCopy(
      classified.outcome,
      showSize,
      showAlt,
      garment,
      preferredFit,
      ptpSame,
      conflict || lengthBlocksPtp
    );

    var whyParts = [
      'Body chest from H/W ≈ ' +
        bodyChest.toFixed(1) +
        '" (BMI ' +
        chestInfo.bmi.toFixed(1) +
        '; build NOT multiplied into mean). Build soft-nudge scale=' +
        buildNudgeScale +
        ', unc_extra=' +
        chestInfo.buildUncExtraIn +
        '".'
    ];
    if (ptpSame) {
      whyParts.push(
        'Same-category PTP=' +
          favoritePtp +
          '" (fit-nudge target ' +
          ptpTarget.toFixed(2) +
          '") compared directly to chestFlat; ' +
          primary.size +
          ' flat=' +
          primary.chestFlat +
          '" (Δ ' +
          (primary.ptpDelta >= 0 ? '+' : '') +
          primary.ptpDelta.toFixed(2) +
          '" vs favorite).'
      );
    } else {
      whyParts.push(
        primary.size +
          ' ' +
          garment +
          ' flat ' +
          primary.chestFlat +
          '" → circ ' +
          primary.garmentCirc.toFixed(1) +
          '" → ease ' +
          primary.ease.toFixed(1) +
          '" (provisional target ' +
          easeT.target.toFixed(1) +
          '" for ' +
          preferredFit +
          ').'
      );
    }
    whyParts.push(
      'Length ' +
        primary.length +
        '" vs preferred ' +
        prefLen.toFixed(1) +
        '" (δ ' +
        (primary.lengthDelta >= 0 ? '+' : '') +
        primary.lengthDelta.toFixed(1) +
        '"). Outcome=' +
        classified.outcome +
        '.'
    );

    return {
      garment: garment,
      inputs: {
        heightIn: heightIn,
        weightLb: weightLb,
        build: build,
        preferredFit: preferredFit,
        favoritePtp: favoritePtp != null ? favoritePtp : null,
        ptpGarmentType: ptpGarmentType != null ? ptpGarmentType : null,
        ptpSameCategory: ptpSame,
        ptpCrossCategoryIgnored: ptpCross
      },
      estimates: Object.assign({}, chestInfo, {
        preferredLengthIn: round3(prefLen),
        easeTarget: easeT.target,
        easeBand: [easeT.min, easeT.max],
        easeBandWithUncertainty: [round2(easeMinP), round2(easeMaxP)],
        lengthBandWithUncertainty: [round2(lenLoP), round2(lenHiP)],
        chestUncertaintyIn: round2(chestUnc),
        easeTargetsProvisional: EASE_TARGETS_PROVISIONAL,
        ptpTargetFlat: ptpTarget == null ? null : round3(ptpTarget),
        buildNudgeApplied: round4(nudgeBase)
      }),
      plausibleBeforeFitPref: plausibleBeforeFit,
      plausibleForPreferredFit: allEmpty
        ? []
        : candidateSet.map(function (ev) {
            return ev.size;
          }),
      usedExpandedBands: usedExpanded,
      allBandsEmpty: allEmpty,
      chestPreferredSize: byChest.size,
      lengthPreferredSize: byLength.size,
      dimensionConflict: conflict,
      strongDimensionConflict: strongConflict,
      lengthBlocksPtp: lengthBlocksPtp,
      primary: showSize,
      alternate: showAlt,
      primaryDist: primary.dist != null ? round4(primary.dist) : null,
      alternateDist: alternate == null ? null : round4(alternate.dist),
      outcome: classified.outcome,
      outcomeLabel: OUTCOME_LABELS[classified.outcome],
      outcomeReasons: classified.reasons,
      customerMessage: customerMessage,
      whyPlausible: whyParts.join(' '),
      warnings: warnings,
      evidenceHierarchyUsed: ptpSame
        ? ['same_category_ptp', 'height_length', 'hw_ease_secondary', 'build_off']
        : [
            'height_length',
            'hw_body_scale_ease',
            'build_soft_nudge',
            'provisional_ease_targets'
          ],
      sizeEvals: evals.map(function (ev) {
        return {
          size: ev.size,
          length: ev.length,
          chestFlat: ev.chestFlat,
          garmentCirc: ev.garmentCirc,
          ease: ev.ease,
          lengthDelta: ev.lengthDelta,
          ptpDelta: ev.ptpDelta,
          chestOkPrimary: ev.chestOkPrimary,
          lengthOkPrimary: ev.lengthOkPrimary,
          ptpOkPrimary: ev.ptpOkPrimary,
          inPlausiblePrimary: ev.inPlausiblePrimary,
          inPlausibleExpanded: ev.inPlausibleExpanded,
          dist: ev.dist == null ? null : round4(ev.dist),
          distComponents: ev.distComponents
        };
      })
    };
  }

  function p1EasePair(easeSp, easeSa, eStar, uncChest) {
    var dSp = easeSp - eStar;
    var dSa = easeSa - eStar;
    var r = Math.max(Number(uncChest), CIRC_HALF);
    var straddles = dSp * dSa <= 0.0 && Math.max(Math.abs(dSp), Math.abs(dSa)) <= CIRC_STEP;
    var bothNear = Math.abs(dSp) <= r && Math.abs(dSa) <= r;
    return {
      ok: straddles || bothNear,
      debug: {
        deltaSp: round4(dSp),
        deltaSa: round4(dSa),
        R: round4(r),
        straddle: straddles,
        bothNear: bothNear,
        circStep: CIRC_STEP,
        circHalf: CIRC_HALF
      }
    };
  }

  function evaluateP1(result, useMarginGate, deltaP1) {
    if (useMarginGate == null) useMarginGate = USE_P1A_MARGIN_GATE;
    if (deltaP1 == null) deltaP1 = DELTA_P1;
    var debug = {
      fired: false,
      reason: null,
      candidateSa: null,
      easePair: null,
      margin: null,
      deltaP1: useMarginGate ? deltaP1 : null,
      useMarginGate: useMarginGate,
      predicates: {}
    };

    var inp = result.inputs;
    var ptpSame = !!inp.ptpSameCategory;
    debug.predicates.ptpAbsent = !ptpSame;
    if (ptpSame) {
      debug.reason = 'ptp_present';
      return debug;
    }
    if (result.outcome === OUTCOME_C || result.allBandsEmpty) {
      debug.predicates.notOutcomeC = false;
      debug.reason = 'outcome_c';
      return debug;
    }
    debug.predicates.notOutcomeC = true;

    var sp = result.primary;
    var evals = {};
    for (var i = 0; i < result.sizeEvals.length; i++) {
      evals[result.sizeEvals[i].size] = result.sizeEvals[i];
    }

    var primaryPlausible = result.sizeEvals
      .filter(function (e) {
        return e.inPlausiblePrimary;
      })
      .map(function (e) {
        return e.size;
      });
    debug.predicates.primaryPlausible = primaryPlausible;
    if (primaryPlausible.indexOf(sp) < 0) {
      debug.reason = 'primary_not_in_primary_plausible';
      debug.predicates.spInPrimaryPlausible = false;
      return debug;
    }
    debug.predicates.spInPrimaryPlausible = true;

    var adj = primaryPlausible.filter(function (s) {
      return Math.abs(SIZE_INDEX[s] - SIZE_INDEX[sp]) === 1;
    });
    debug.predicates.adjacentInPrimaryPlausible = adj;
    if (!adj.length) {
      debug.reason = 'no_adjacent_in_primary_plausible';
      return debug;
    }

    var eStar = Number(result.estimates.easeTarget);
    var unc = Number(result.estimates.chestUncertaintyIn);
    var easeSp = Number(evals[sp].ease);

    var scored = {};
    for (var j = 0; j < result.sizeEvals.length; j++) {
      var se = result.sizeEvals[j];
      if (se.dist != null) scored[se.size] = se.dist;
    }
    if (!(sp in scored)) {
      debug.reason = 'primary_unscored';
      return debug;
    }

    var qualifying = [];
    for (var ai = 0; ai < adj.length; ai++) {
      var sa = adj[ai];
      var pair = p1EasePair(easeSp, Number(evals[sa].ease), eStar, unc);
      var lenOk = !!evals[sa].lengthOkPrimary && !!evals[sp].lengthOkPrimary;
      if (!(pair.ok && lenOk && sa in scored)) continue;
      var margin = Number(scored[sa]) - Number(scored[sp]);
      if (useMarginGate && margin > deltaP1) continue;
      qualifying.push({ dist: scored[sa], sa: sa, ep: pair.debug, margin: margin });
    }
    debug.predicates.qualifyingAdjacent = qualifying.map(function (q) {
      return { sa: q.sa, dist: q.dist, margin: q.margin, easePair: q.ep };
    });
    if (!qualifying.length) {
      debug.reason = 'no_qualifying_ease_pair_or_margin';
      return debug;
    }

    qualifying.sort(function (a, b) {
      if (a.dist !== b.dist) return a.dist - b.dist;
      return SIZE_INDEX[a.sa] - SIZE_INDEX[b.sa];
    });
    var best = qualifying[0];
    debug.candidateSa = best.sa;
    debug.easePair = best.ep;
    debug.margin = round4(best.margin);
    debug.predicates.adjacency = Math.abs(SIZE_INDEX[sp] - SIZE_INDEX[best.sa]) === 1;
    debug.predicates.bothPrimaryPlausible = true;
    debug.predicates.easePairOk = true;
    debug.predicates.lengthOkBoth = true;
    debug.predicates.marginOk = !useMarginGate || best.margin <= deltaP1;
    debug.fired = true;
    debug.reason = useMarginGate ? 'p1a_ease_adjacent_support' : 'p1_ease_adjacent_support';
    debug.saDist = best.dist;
    debug.spDist = scored[sp];
    debug.currentAlternate = result.alternate;
    debug.introducesAlt = result.alternate == null;
    return debug;
  }

  function classifyReportOutcome(result, p1, applyP1) {
    if (result.outcome === OUTCOME_C) return 'C';
    if (applyP1 && p1.fired && p1.introducesAlt) return 'B1';
    var alt = result.alternate;
    if (applyP1 && p1.fired && !p1.introducesAlt) {
      if (result.outcome === OUTCOME_A && alt) return 'A';
      return 'B1';
    }
    if (result.outcome === OUTCOME_A) return 'A';
    if (alt) return 'B1';
    if (result.outcome === OUTCOME_B) return 'B2';
    return 'C';
  }

  function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function recommendWithP1(
    garment,
    heightIn,
    weightLb,
    build,
    preferredFit,
    favoritePtp,
    ptpGarmentType,
    enableP1,
    useMarginGate
  ) {
    if (enableP1 == null) enableP1 = true;
    if (useMarginGate == null) useMarginGate = USE_P1A_MARGIN_GATE;

    var base = recommend(
      garment,
      heightIn,
      weightLb,
      build,
      preferredFit,
      favoritePtp,
      ptpGarmentType
    );
    var p1 = evaluateP1(base, useMarginGate, DELTA_P1);
    var out = deepClone(base);
    out.p1 = p1;
    out.currentAlternate = base.alternate;
    out.currentOutcome = base.outcome;

    var p1Uncapped = evaluateP1(base, false, DELTA_P1);
    out.p1Uncapped = {
      fired: p1Uncapped.fired,
      introducesAlt: p1Uncapped.introducesAlt,
      candidateSa: p1Uncapped.candidateSa,
      margin: p1Uncapped.margin,
      reason: p1Uncapped.reason
    };

    if (enableP1 && p1.fired && p1.introducesAlt) {
      var sa = p1.candidateSa;
      out.alternate = sa;
      var saDist = null;
      for (var i = 0; i < base.sizeEvals.length; i++) {
        if (base.sizeEvals[i].size === sa) {
          saDist = base.sizeEvals[i].dist;
          break;
        }
      }
      out.alternateDist = saDist;
      out.p1IntroducedAlternate = true;
      if (out.outcome === OUTCOME_A) {
        out.outcome = OUTCOME_B;
        out.outcomeLabel = OUTCOME_LABELS[OUTCOME_B];
      }
      var reasons = (out.outcomeReasons || []).slice();
      var tag = useMarginGate ? 'p1a_adjacent_ease_support' : 'p1_adjacent_ease_support';
      if (reasons.indexOf(tag) < 0) reasons.push(tag);
      if (reasons.indexOf('close_call_between_sizes') < 0) reasons.push('close_call_between_sizes');
      out.outcomeReasons = reasons;
      out.customerMessage = customerCopy(
        out.outcome,
        out.primary,
        out.alternate,
        garment,
        preferredFit,
        !!(base.inputs && base.inputs.ptpSameCategory),
        !!(base.dimensionConflict || base.lengthBlocksPtp)
      );
    } else {
      out.p1IntroducedAlternate = false;
    }

    out.reportOutcomeCurrent = classifyReportOutcome(base, p1, false);
    out.reportOutcomeP1 = classifyReportOutcome(out, p1, enableP1);

    if (enableP1 && p1Uncapped.fired && p1Uncapped.introducesAlt) {
      out.reportOutcomeP1Uncapped = 'B1';
    } else {
      out.reportOutcomeP1Uncapped = classifyReportOutcome(base, p1Uncapped, false);
      if (p1Uncapped.fired && !p1Uncapped.introducesAlt) {
        if (base.outcome !== OUTCOME_A || base.alternate) {
          if (base.outcome !== OUTCOME_C) {
            out.reportOutcomeP1Uncapped =
              base.alternate || base.outcome === OUTCOME_B
                ? 'B1'
                : out.reportOutcomeP1Uncapped;
          }
        }
        if (base.alternate) out.reportOutcomeP1Uncapped = 'B1';
      }
    }
    return out;
  }

  /**
   * Public frozen API — always applies P1a.
   * @param {{garment:string, heightIn:number, weightLb:number, build:string, preferredFit:string, favoritePtp?:number, ptpGarmentType?:string}} opts
   */
  function frozenRecommend(opts) {
    if (!USE_P1A_MARGIN_GATE) throw new Error('Frozen path requires USE_P1A_MARGIN_GATE=True');
    var garment = opts.garment;
    var heightIn = opts.heightIn;
    var weightLb = opts.weightLb;
    var build = opts.build;
    var preferredFit = opts.preferredFit;
    var favoritePtp = opts.favoritePtp != null ? opts.favoritePtp : null;
    var ptpGarmentType =
      opts.ptpGarmentType != null
        ? opts.ptpGarmentType
        : favoritePtp != null
          ? garment
          : null;

    var out = recommendWithP1(
      garment,
      heightIn,
      weightLb,
      build,
      preferredFit,
      favoritePtp,
      ptpGarmentType,
      true,
      true
    );
    out.frozenVersion = FROZEN_VERSION;
    out.frozenP1a = true;
    out.frozenDeltaP1 = DELTA_P1;
    return out;
  }

  return {
    FROZEN_VERSION: FROZEN_VERSION,
    DELTA_P1: DELTA_P1,
    SIZES: SIZES,
    SIZE_INDEX: SIZE_INDEX,
    frozenRecommend: frozenRecommend,
    recommend: recommend,
    recommendWithP1: recommendWithP1,
    evaluateP1: evaluateP1
  };
});
